import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import BeginnersArticle from "../pages/article/beginners/page";
import ComparisonArticle from "../pages/article/comparison/page";
import SafetyArticle from "../pages/article/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/hipobuy-spreadsheet-beginners",
    element: <BeginnersArticle />,
  },
  {
    path: "/spreadsheet-platform-comparison",
    element: <ComparisonArticle />,
  },
  {
    path: "/hipobuy-spreadsheet-safety",
    element: <SafetyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;